<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <!-- <th v-show="editMode" width="20">
                        </th> -->
                        <th v-show="editMode" width="20">EDIT</th>
                        <th> COLUMN NAME  </th>
                        <th> HOUSE TYPE  </th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(col, i) in HP_RESTRICTIONS" :key="i">
                         <!-- <td v-show="editMode">
                            <v-checkbox v-model="col.selected" dense></v-checkbox>
                        </td> -->
                        <td v-show="editMode"> 
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(col)"
                            >
                                <v-icon >mdi-pencil</v-icon> 
                            </v-btn>
                        </td>
                        <td> {{ col.column_name }} </td>
                        <!-- <td> {{ col.house_name }} </td> -->
                        <td> 
                            <v-chip small class="mr-1" v-for="(house, ii) in col.house_types" :key="ii+i+'rem'">
                                <span class="caption font-weight-black">
                                {{ house.name }}
                                </span> 
                            </v-chip>
                        </td>
                        <td v-show="viewMode"> {{ formatDate(col.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(col.updated_at) }} </td>
                        <td v-show="viewMode"> {{ col.created_by }} </td>
                        <td v-show="viewMode"> {{ col.updated_by }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
        <!-- mainTable End -->

            
        </v-container>

        <!-- Dialogs -->
        <!-- dialogStore Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Create HP Column Restriction</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete 
                                        outlined 
                                        dense 
                                        :items="HP_COLUMNS"
                                        item-text="column_name"
                                        item-value="id"
                                        label="Column Name"
                                        name="column_id" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete 
                                        multiple
                                        outlined 
                                        dense 
                                        label="House Type"
                                        name="house_type_id" 
                                        class="required"
                                        :items="HOUSE_TYPES"
                                        item-text="name"
                                        item-value="id"
                                        :rules="rules.required"
                                    > </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Start -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit Column Name</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                               <v-col cols="12">
                                    <v-autocomplete 
                                        v-model="tempData.column_id"
                                        outlined 
                                        dense 
                                        :items="HP_COLUMNS"
                                        item-text="column_name"
                                        item-value="id"
                                        label="Column Name"
                                        name="column_name" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-autocomplete>
                                </v-col>
                               <v-col cols="12">
                                    <v-autocomplete
                                        v-model="tempData.house_types" 
                                        multiple
                                        name="house_type"
                                        outlined 
                                        :items="HOUSE_TYPES"
                                        item-text="name"
                                        item-value="id"
                                        label="House Type"
                                        class="required"
                                        :rules="rules.required"
                                        chips
                                        small-chips
                                    >
                                        <template v-slot:selection="data">
                                                <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                close
                                                small
                                                @click:close="remove(data.item)"
                                            >
                                                {{ data.item.name }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer :items="HP_RESTRICTIONS.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
    export default {
        components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'HP COLUMN RESTRICTION FOR HOUSE TYPES',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            floatButtons:{
                add: false,
                update: true,
                delete: false
            },

            tempData: {},
            
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,


        }),

        computed : {
            ...mapState([
                'HP_COLUMNS',
                'HP_RESTRICTIONS',
                'HOUSE_TYPES',
                'rules',
                'viewMode',
                'editMode'
            ]),

            selectedData(){
                // this will return only the id of the selected data
                return this.HP_RESTRICTIONS.filter(res => res.selected).map(res => res.id); 
            }
        },

        methods: {
            ...mapActions([
                '_getHpColumn',
                '_getHpRestriction',
                '_getHouseTypes',
            ]),

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogStore(val){
                this.dialogStore = val;
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);

                    axios({
                        method: 'POST',
                        url: '/api/hp_res/store',
                        data: formdata
                    }).then(() => {
                        this._getHpRestriction();
                        this.dialogStore = false;
                    })
                }
            },

            toggleUpdateDialog(item){
                this.tempData = {}
                if(item){
                    this.tempData = {...item};
                    this.tempData.house_types = item.house_types.map((res) => {
                        return res.house_type_id;
                    })
                    this.tempData.column_id = item.id
                    console.log(this.tempData)
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Update(){
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/hp_res/update`,
                        data: formdata
                    }).then(() => {
                        this._getHpRestriction();
                        this.dialogUpdate = false;
                    })
                }
            },

            
            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/hp_col/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getHpRestriction();
                    this.dialogDelete = false;
                })
            }
        },

        mounted() {
            this._getHpColumn();
            this._getHpRestriction();
            this._getHouseTypes();
        },

        watch:{
            dialogStore(value){
                if( ! value ) this.$refs.Store.reset();
            },

            dialogUpdate(value){
                if( ! value ) this.$refs.Update.reset();
            },

        }
    }
</script>

<style scoped>


</style>